import React, { Component } from "react";
import Logo from "../../components/Logo";
import Footer from "../../components/Footer";
import Menu from "../../components/Menu";
import ToggleMenu from "../../components/ToggleMenu";
import { Wrapper, Header, Shoable } from "./style";

class Navigation extends Component {
  render() {
    return (
      <Wrapper>
        <Shoable>
          <Logo />
          {/* <div> */}
          {/* <Menu /> */}
          {/* <Footer /> */}
          {/* </div> */}
        </Shoable>
      </Wrapper>
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation/index.js